import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If Puppeteer prerendered the HTML at build time (see scripts/prerender.js),
// `<html data-prerendered="true">` is set. In that case hydrate on top of the
// existing DOM. Otherwise mount from scratch as usual.
if (document.documentElement.dataset.prerendered === "true" && rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(tree);
}
